import {
  InsuredLocationPatchRequestBody,
  InsuredLocationRequestParams,
  InsuredLocationPostResponse,
} from '@lio/api-types';
import { customerQueryKey } from '@services/customer/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useUpdateInsuredLocations = (quoteId: string) => {
  const client = useClient();
  const queryClient = useQueryClient();
  const mutationFn = ({
    customerId,
    insuredLocationId,
    approvedAddress,
    status,
    isPrimary,
  }: InsuredLocationPatchRequestBody & InsuredLocationRequestParams) =>
    client
      .patch(`customer/${customerId}/insured-location/${insuredLocationId}`, {
        json: {
          approvedAddress,
          status,
          isPrimary,
        },
      })
      .json<InsuredLocationPostResponse>();

  const result = useMutation({
    mutationFn,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['quote', { quoteId }],
      });
      queryClient.invalidateQueries({
        queryKey: [...customerQueryKey._customerLocation(data.customerId), 'list'],
      });
      queryClient.invalidateQueries({
        queryKey: [...customerQueryKey._customerBrokerage(data.customerId), 'metadata'],
      });
    },
  });
  return { ...result, updateInsuredLocations: result.mutateAsync };
};
